interface IError {
	codeName: string,
	description?: string
}

class Result<T> {
	data = null as T|null;
	errors = [] as IError[];

	get isSuccess() {
		return (this.errors.length == 0);
	}

	get isFailure() {
		return (this.errors.length > 0);
	}

	success(data:T|null) : Result<T> {
		this.data = data;
		this.errors = [];
		return this;
	}

	failure(errors:IError[]) : Result<T> {
		this.data = null;
		this.errors = errors;
		return this;
	}
}

export default Result;
export { IError };